import { render, staticRenderFns } from "./Investimento.vue?vue&type=template&id=bb83284c&scoped=true&lang=pug"
import script from "./Investimento.vue?vue&type=script&lang=js"
export * from "./Investimento.vue?vue&type=script&lang=js"
import style0 from "./Investimento.styl?vue&type=style&index=0&id=bb83284c&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb83284c",
  null
  
)

export default component.exports